/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-console */
import {useNavigate} from 'react-router-dom';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';
import {toast} from 'react-toastify';

import type {ISubscriberProfile, PersonalPCCS} from 'interfaces';
import {useDeleteSubscriptionDataMutation} from 'services';

import 'react-confirm-alert/src/react-confirm-alert.css';

type TProps = {
	dataProfile: ISubscriberProfile | null;
	refetch: (subscriberId: string) => Promise<void>;
	type: string;
	isDisabled: boolean;
};
const TableSubscritionProfile = ({
	dataProfile,
	refetch,
	type,
	isDisabled,
}: TProps) => {
	const navigate = useNavigate();

	// api
	const [deleteRowUeId] = useDeleteSubscriptionDataMutation();

	/**
	 * It returns an object with the properties that the modal component needs to render
	 * @param {ISubscriberProfile} item - ISubscriberProfile - The item that is being passed to the modal.
	 */
	const optionsRemoveModal = (item: ISubscriberProfile) => ({
		title: 'Do you really want to remove this profile?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				// eslint-disable-next-line @typescript-eslint/require-await
				onClick: async () => {
					try {
						void deleteRowUeId(item.subscriberId);
						await refetch(item.subscriberId);
						toast.success('Deleted Subscriber Successfully!');
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	/**
	 * The handleRemove function is used to display a confirmation modal before removing an item.
	 * @param {ISubscriberProfile} item - The `item` parameter is of type `ISubscriberProfile`. It represents
	 * the data plan template that needs to be removed.
	 */
	const handleRemove = (item: ISubscriberProfile) =>
		confirmAlert(optionsRemoveModal(item));

	const getPersonalPCCCount = (
		personalPCCs: PersonalPCCS | null | undefined,
	): number => {
		if (!personalPCCs) return 0;
		return Object.keys(personalPCCs).length;
	};

	return (
		<div className="panel-body">
			<div className="col-md-12 mt-4 ">
				{' '}
				<div className="table-responsive h500 mt-2">
					{dataProfile ? (
						<table className="table table-striped table-sm table-head-fixed text-nowrap">
							<thead>
								<tr>
									<th className="col-1">SUPI</th>
									<th className="col-1">GPSI</th>
									<th className="col-3">Categories</th>
									<th className="col-1">Home Zones</th>
									<th className="col-1">Personal PCC items</th>
									<th className="col-1">Personal QoS items</th>
									<th className="col-1">Plans subscribed</th>
									{!isDisabled && <th className="col-1">Actions</th>}
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{dataProfile?.supi || '-'}</td>
									<td>{dataProfile?.gpsi || '-'}</td>
									<td>
										{dataProfile?.smPolicySnssaiData &&
										Object.values(dataProfile.smPolicySnssaiData).length > 0
											? Object.values(
													dataProfile.smPolicySnssaiData,
											  )[0].smPolicyDnnData[0]?.subscCats?.join(', ')
											: '-'}
									</td>
									<td>
										{dataProfile.homeZones
											? Object.keys(dataProfile.homeZones).length
											: '-'}
									</td>
									<td>
										{getPersonalPCCCount(
											dataProfile.personalPCCs ?? undefined,
										) || '-'}
									</td>
									<td>
										{dataProfile.personalQos
											? Object.keys(dataProfile.personalQos).length
											: '-'}
									</td>
									<td>{dataProfile?.planInstanceIdList?.length ?? '-'}</td>
									{!isDisabled && (
										<td>
											<button
												className="border-0 bg-transparent d-inline"
												onClick={() =>
													navigate(
														`/subscriberProfile/detail/${String(
															dataProfile.subscriberId,
														)}`,
														{
															state: dataProfile,
														},
													)
												}>
												<i
													className="bi-1 bi-pencil"
													title="Edit"
													data-toggle="tooltip"
												/>
											</button>

											<button
												className="border-0 bg-transparent d-inline"
												onClick={() => handleRemove(dataProfile)}>
												<i
													className="bi-1 bi-trash-fill text-danger"
													title=""
													data-toggle="tooltip"
													data-original-title="Delete"
												/>
											</button>
										</td>
									)}
								</tr>
							</tbody>
						</table>
					) : (
						<div className="text-center">
							<span className="h6">No data</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default TableSubscritionProfile;
